import { Divider } from '@chakra-ui/react';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import { CONTENT_GROUP_TYPE_NAMES } from 'features/content-groups/components/ContentGroupsList';
import { useContentGroup } from 'features/content-groups/hooks/useContentGroup';
import { useParams } from 'react-router-dom';
import ListContents from '../components/ListContents';

export default function PageSelectContent() {
  const { id } = useParams();
  const { data: contentGroup } = useContentGroup(id);
  
  return (
    <>
      <HeaderBarInternal
        title={contentGroup ? `Novo disparo de ${CONTENT_GROUP_TYPE_NAMES[contentGroup.type]} - ${contentGroup.name}`: 'Novo disparo'}
        backTo="/disparos-de-report"
      >
      </HeaderBarInternal>
      
      <Divider />
      
      <ListContents />
    </>
  )
}